import { render, staticRenderFns } from "./globalSearch.vue?vue&type=template&id=2caae4a4&scoped=true&"
import script from "./globalSearch.vue?vue&type=script&lang=js&"
export * from "./globalSearch.vue?vue&type=script&lang=js&"
import style0 from "./globalSearch.vue?vue&type=style&index=0&id=2caae4a4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2caae4a4",
  null
  
)

export default component.exports